import { defineTokens } from '@chakra-ui/react'

export const fonts = defineTokens.fonts({
  body: {
    value: 'Tahoma, Roboto, sans-serif;',
  },
  heading: {
    // `--font-bricolage` is provided by next/font (see app/layout.tsx).
    value: 'var(--font-bricolage), Tahoma, Roboto, sans-serif;',
  },
  mono: {
    value:
      'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
  },
})
